import { useMutation, useQueryClient } from '@tanstack/react-query';
import { registerStoragebox } from '../api/storagebox/getStoragebox';
import { StorageboxData } from '../@types/storagebox';

export const useRegisterStoragebox = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isSuccess, isLoading } = useMutation(
    async (formData: StorageboxData) => {
      const data = await registerStoragebox(formData);
      return data;
    },
    {
      onSuccess: () => queryClient.invalidateQueries(['products-status']),
      onError: () => queryClient.invalidateQueries(['products-status']),
    },
  );
  return { mutate: mutateAsync, isSuccess, isLoading };
};
